import React from 'react'
import { createFallbackComponent } from './fallback'

let VideoPlayer = null

try {
  const runnerModule = require('@protonapp/runner-video-player') // eslint-disable-line global-require
  VideoPlayer = runnerModule?.default || runnerModule
} catch (err) {
  console.warn('Proton video player module not found:', err)
  VideoPlayer = createFallbackComponent(
    'Video playback requires the @protonapp/runner-video-player package.'
  )
}

export default function Video(props) {
  return <VideoPlayer {...props} />
}
